module.exports = __webpack_public_path__ + "img/2-1.18e997b4.jpg";